import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import Tooltip from '@material-ui/core/Tooltip';

import { AppTheme } from '../../../../styles/AppTheme';

export function AutomationNodePalette(props) {
  const saveDisabled = !!props.saveDisabled;
  return (
    <div className={css(Styles.bar)}>
      <div className={css(Styles.row)}>
        <button
          type='button'
          className={css(Styles.chip)}
          onClick={props.onChangeTrigger}
        >
          <i className={'material-icons-outlined ' + css(Styles.chipIcon)}>flag</i>
          Change Trigger
        </button>
        <button
          type='button'
          className={css(Styles.chip)}
          onClick={props.onAddAction}
        >
          <i className={'material-icons-outlined ' + css(Styles.chipIcon)}>bolt</i>
          Add Action
        </button>
        <div className={css(Styles.spacer)} />
        <div className={css(Styles.actions)}>
          <Tooltip title={props.saveTooltip || 'Save'} arrow>
            <span className={css(Styles.saveWrap)}>
              <button
                type='button'
                className={css(Styles.saveBtn, saveDisabled && Styles.saveBtnDisabled)}
                disabled={saveDisabled}
                onClick={saveDisabled ? undefined : props.onSave}
              >
                <i className={'material-icons-outlined ' + css(Styles.saveIcon)}>save</i>
                Save
              </button>
            </span>
          </Tooltip>
        </div>
      </div>
    </div>
  );
}

const Styles = StyleSheet.create({
  bar: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: 10,
    padding: 12,
    boxSizing: 'border-box',
    borderBottom: '1px solid ' + AppTheme.borderColor,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
  },
  spacer: {
    flex: 1,
    minWidth: 0,
  },
  chip: {
    minWidth: 96,
    height: 36,
    padding: '0 14px',
    borderRadius: 8,
    border: '1px solid ' + AppTheme.borderColor,
    backgroundColor: AppTheme.secondaryBg,
    color: '#222222',
    fontSize: 13,
    fontWeight: 600,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    flexShrink: 0,
    ':hover': {
      borderColor: AppTheme.primaryColor,
    },
  },
  chipIcon: {
    fontSize: 18,
    color: '#6B7280',
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    flexShrink: 0,
  },
  saveWrap: {
    flexShrink: 0,
  },
  saveBtn: {
    height: 36,
    padding: '0 14px',
    borderRadius: 8,
    border: '1px solid ' + AppTheme.primaryColor,
    backgroundColor: AppTheme.primaryColor,
    color: '#ffffff',
    fontSize: 13,
    fontWeight: 600,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
  },
  saveBtnDisabled: {
    borderColor: AppTheme.borderColor,
    backgroundColor: AppTheme.secondaryBg,
    color: '#AAAAAA',
    cursor: 'not-allowed',
  },
  saveIcon: {
    fontSize: 18,
  },
});
